import SEO from '../components/SEO';
import { useState } from 'react';
import { Mail, Send } from 'lucide-react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  return (
    <main data-testid="contact-page" style={{ backgroundColor: '#F7F7F5', minHeight: '100vh', padding: '80px 0' }}>
      <SEO
        title="Contact RELOAD | Get in Touch"
        description="Contact the RELOAD team. Questions about our male performance supplement, your order, or delivery? We're here to help."
        canonical="/contact"
      />
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="overline block mb-4">Get in Touch</span>
          <h1 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#0D1A2E', letterSpacing: '-0.025em' }}>Contact Us</h1>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '1rem', color: '#64748B', marginTop: '12px', lineHeight: 1.75 }}>
            Have a question about RELOAD? Our team is here to help.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Info */}
          <div className="flex flex-col gap-4">
            {[
              { icon: Mail, title: 'Email Us', value: 'contact@reload-nutrition.com', sub: 'We respond within 24 hours' },
            ].map(({ icon: Icon, title, value, sub }) => (
              <div key={title} className="card-light rounded-2xl p-5">
                <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                  <div className="icon-bg-blue">
                    <Icon size={18} style={{ color: '#1B3D7E' }} strokeWidth={1.5} />
                  </div>
                  <div>
                    <p style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: '0.9rem', color: '#0D1A2E', marginBottom: '3px' }}>{title}</p>
                    <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.82rem', color: '#0D1A2E' }}>{value}</p>
                    <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: '#64748B', marginTop: '2px' }}>{sub}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Form */}
          <div className="md:col-span-2">
            <div className="card-light rounded-2xl p-8">
              {sent ? (
                <div className="text-center py-8" data-testid="contact-success">
                  <div style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: 'rgba(27,61,126,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                    <Send size={24} style={{ color: '#1B3D7E' }} />
                  </div>
                  <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.4rem', fontWeight: 700, color: '#0D1A2E', marginBottom: '10px' }}>Message Sent!</h3>
                  <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.9rem', color: '#64748B' }}>We&apos;ll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={e => { e.preventDefault(); setSent(true); }} data-testid="contact-form">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                    {[{ id: 'name', label: 'Full Name', type: 'text', placeholder: 'John Smith' }, { id: 'email', label: 'Email Address', type: 'email', placeholder: 'john@example.com' }].map(({ id, label, type, placeholder }) => (
                      <div key={id}>
                        <label style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', color: '#64748B', display: 'block', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>{label}</label>
                        <input type={type} id={id} data-testid={`contact-${id}`} placeholder={placeholder} value={form[id]} onChange={e => setForm({ ...form, [id]: e.target.value })} required style={{ width: '100%', backgroundColor: '#F7F7F5', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '12px 16px', color: '#0D1A2E', fontFamily: 'Manrope, sans-serif', fontSize: '0.9rem', outline: 'none' }} />
                      </div>
                    ))}
                  </div>
                  <div className="mb-5">
                    <label style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', color: '#64748B', display: 'block', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>Subject</label>
                    <input type="text" data-testid="contact-subject" placeholder="How can we help?" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} style={{ width: '100%', backgroundColor: '#F7F7F5', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '12px 16px', color: '#0D1A2E', fontFamily: 'Manrope, sans-serif', fontSize: '0.9rem', outline: 'none' }} />
                  </div>
                  <div className="mb-6">
                    <label style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', color: '#64748B', display: 'block', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>Message</label>
                    <textarea rows={5} data-testid="contact-message" placeholder="Tell us what's on your mind..." value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required style={{ width: '100%', backgroundColor: '#F7F7F5', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '12px 16px', color: '#0D1A2E', fontFamily: 'Manrope, sans-serif', fontSize: '0.9rem', outline: 'none', resize: 'vertical' }} />
                  </div>
                  <button type="submit" data-testid="contact-submit" className="btn-blue gap-2 w-full py-4 rounded-full text-xs" style={{ fontFamily: 'Manrope, sans-serif', cursor: 'pointer', border: 'none' }}>
                    <Send size={14} style={{ marginRight: '6px' }} />
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
